import { userServices } from '@/services'
import { Layout } from '@/shared/components/layout'
import { Navigate, Outlet, useNavigate } from 'react-router-dom'
import { usePermify } from '@permify/react-role'
import { useSelector } from 'react-redux'
import { toast } from 'react-toastify'
import { useTranslation } from 'react-i18next'

export const Authenticated = () => {
  console.log('Authenticated rendered')
  const { setUser } = usePermify()
  const { current: user } = useSelector((state) => state.user)

  const navigate = useNavigate()

  const handleLogout = async () => {
    try {
      await userServices.signOut()
      navigate('/sign_in')
    } catch (e) {
      /* handle error */
    }
  }

  const [currentRole = {}] = user?.roles || []
  const permissions = currentRole?.permissionsArray || []

  if (!user?.id) return <Navigate to='/sign_in' />

  setUser({
    id: user?.info?.id,
    roles: [currentRole],
    permissions
  })

  return (
    <Layout handleLogout={handleLogout} >
      < Outlet />
    </Layout >
  )
}

export const LayoutWithError = () => {
  console.log('LayoutWithError rendered')
  const { current: user } = useSelector((state) => state.user)
  const { t } = useTranslation()

  if (!user?.id) {
    toast.error(t('alert.user.unauthorized'))
    return <Navigate to='/sign_in' />
  }

  return (
    <Layout>
      <div>Error</div>
    </Layout>
  )
}
